// // import'bootstrap/dist/css/bootstrap.css';
// import'bootstrap/dist/css/bootstrap-theme.css';
import React, { lazy, Suspense } from "react";
import "./App.css";
import $ from "jquery";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

// Import fonts
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
// Supports weights 100-900
import "@fontsource-variable/overpass/wght.css";

// Lazy load components
const Home = lazy(() => import("../../pages/home"));
const ForgotPassword = lazy(() => import("../../pages/forgotPassword"));
const ResetPassword = lazy(() => import("../../pages/resetPassword"));
const ResetSuccess = lazy(() => import("../../pages/resetSuccess"));
const Campaigns = lazy(() => import("../../pages/campaigns"));
const MyCampaigns = lazy(() => import("../../pages/myCampaigns"));
const Analytics = lazy(() => import("../../pages/analytics"));
const Summary = lazy(() => import("../../pages/summary"));
const Social = lazy(() => import("../../pages/social"));
const Energy = lazy(() => import("../../pages/energy"));
const SalesDelivery = lazy(() => import("../../pages/salesDelivery"));
const EnergyNew = lazy(() => import("../../pages/energyNew"));
const CampaignOverview = lazy(() => import("../../pages/campaignOverview"));
const CreateCampaign = lazy(() => import("../../pages/createCampaign"));
const CreateHomevisit = lazy(() => import("../../pages/createHomevisit"));
const CreateGroupvisit = lazy(() => import("../../pages/createGroupvisit"));
const CreateDigitalcommunication = lazy(() => import("../../pages/createDigitalCommunication"));
const CreateCommunityevent = lazy(() => import("../../pages/createCommunityEvent"));
const CreateTraining = lazy(() => import("../../pages/createTraining"));
const CreateResearch1 = lazy(() => import("../../pages/createResearch1"));
const CreateResearch2 = lazy(() => import("../../pages/createResearch2"));
const Profile = lazy(() => import("../../pages/profile"));
const Order = lazy(() => import("../../pages/order"));
const Rbfml = lazy(() => import("../../pages/rbfml"));
const Blockchain = lazy(() => import("../../pages/blockchain"));
const OtherCampaigns = lazy(() => import("../../pages/otherCampaigns/OtherCampaigns"));
const FirstLogin = lazy(() => import("../../pages/firstLogin"));
const Dashboard1 = lazy(() => import("../../pages/dashboard1"));
const DashboardV2 = lazy(() => import("../../pages/dashboardV2/dashboardV2"));
const DonorDashboard = lazy(() => import("../../pages/donorDashboard"));
const TrackAndTraceDashboard = lazy(() => import("../../pages/trackNTraceDashboard/TrackAndTraceDashboard"));
const Tableau = lazy(() => import("../../pages/tableau/tableau"));
const TableauV2 = lazy(() => import("../../pages/tableau/tableauV2"));
const TableauProject = lazy(() => import("../../pages/tableauProject/tableauProject"));
const PureDashboard = lazy(() => import("../../pages/pureDashboard"));
const PureDashboardNew = lazy(() => import("../../pages/pureDashboardNew"));
const FunderDashboard = lazy(() => import("../../pages/donorDashboard/FunderDashboard"));
// Loading component
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '18px',
    color: '#666'
  }}>
    <div>Loading...</div>
  </div>
);

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = Boolean(localStorage.getItem("dcUser"));

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

const PRIVATE_ROUTES = [
  { path: "/dashboard", component: DashboardV2 },
  { path: "/tableau-dashboard", component: Tableau },
  { path: "/tableau-dashboard-v2", component: TableauV2 },
  { path: "/tableau-project", component: TableauProject },
  { path: "/pure-dashboard", component: PureDashboard },
  { path: "/pure-dashboard-new", component: PureDashboardNew },
  { path: "/donor-dashboard", component: DonorDashboard },
  { path: "/campaigns", component: Campaigns },
  { path: "/analytics", component: Analytics },
  { path: "/my-campaigns", component: MyCampaigns },
  { path: "/other-campaigns", component: OtherCampaigns },
  { path: "/first", component: FirstLogin },
  { path: "/dashboard1", component: Dashboard1 },
  { path: "/summary", component: Summary },
  { path: "/social", component: Social },
  { path: "/energy", component: EnergyNew },
  { path: "/energy-new", component: Energy },
  { path: "/ananta-track-trace", component: TrackAndTraceDashboard },
  { path: "/campaign-overview/:id", component: CampaignOverview },
  { path: "/create-campaign", component: CreateCampaign },
  { path: "/create-homevisit/:id", component: CreateHomevisit },
  { path: "/create-groupvisit/:id", component: CreateGroupvisit },
  { path: "/create-digital-communication/:id", component: CreateDigitalcommunication },
  { path: "/create-community-event/:id", component: CreateCommunityevent },
  { path: "/create-training/:id", component: CreateTraining },
  { path: "/create-research1/:id", component: CreateResearch1 },
  { path: "/create-research2/:id", component: CreateResearch2 },
  { path: "/profile", component: Profile },
  { path: "/orders", component: Order },
  { path: "/rbf-ml/:id?", component: Rbfml },
  { path: "/blockchain", component: Blockchain },
];

const PUBLIC_ROUTES = [
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/reset-password/:id", component: ResetPassword },
  { path: "/reset-success", component: ResetSuccess },
  { path: "/", component: Home },
];

class App extends React.Component {
  componentDidMount() {
    if (localStorage.getItem("dhUser")) {
      let user = JSON.parse(localStorage.getItem("dhUser"));
      $.ajaxSetup({
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "JWT " + user.token);
        },
      });
    }
  }

  render() {
    return (
      <Router>
        <Suspense fallback={<LoadingFallback />}>
          <Switch>
            {PRIVATE_ROUTES.map(({ path, component, exact = true }) => (
              <PrivateRoute key={path} path={path} component={component} exact={exact} />
            ))}

            {PUBLIC_ROUTES.map(({ path, component: Component, exact = true }) => (
              <Route key={path} path={path} exact={exact}>
                <Component />
              </Route>
            ))}

          <Route path="/tableau-project">
              <TableauProject />
          </Route>

          <Route path="/pure-dashboard">
              <PureDashboard />
          </Route>
          <Route path="/pure-dashboard-new">
              <PureDashboardNew />
          </Route>
          <Route path="/funder/dashboard">
            <FunderDashboard />
          </Route>
          <Route path="/funder/sales-delivery/:id/:projectId">
            {(props) => <SalesDelivery {...props} />}
          </Route>
          <Route path="/funder/sales-delivery">
            {(props) => <SalesDelivery {...props} />}
          </Route>
          <Route path="/donor-dashboard">
            <DonorDashboard />
          </Route>

          <Route path="/campaigns">
            <Campaigns />
          </Route>

          <Route path="/analytics">
            <Analytics />
          </Route>

          <Route path="/my-campaigns">
            <MyCampaigns />
          </Route>

          <Route path="/other-campaigns">
            <OtherCampaigns />
          </Route>

          <Route path="/first">
            <FirstLogin />
          </Route>

          <Route path="/dashboard1">
            <Dashboard1 />
          </Route>

          <Route path="/summary">
            <Summary />
          </Route>

          <Route path="/social">
            <Social />
          </Route>

          <Route path="/energy">
            <EnergyNew />
          </Route>

          <Route path="/energy-new">
            <Energy />
          </Route>
          
          <Route path="/ananta-track-trace">
            <TrackAndTraceDashboard />
          </Route>

          <Route path="/campaign-overview/:id">
            <CampaignOverview />
          </Route>

          <Route path="/create-campaign">
            <CreateCampaign />
          </Route>

          <Route path="/create-homevisit/:id">
            <CreateHomevisit />
          </Route>

          <Route path="/create-groupvisit/:id">
            <CreateGroupvisit />
          </Route>

          <Route path="/create-digital-communication/:id">
            <CreateDigitalcommunication />
          </Route>

          <Route path="/create-community-event/:id">
            <CreateCommunityevent />
          </Route>

          <Route path="/create-training/:id">
            <CreateTraining />
          </Route>

          <Route path="/create-research1/:id">
            <CreateResearch1 />
          </Route>

          <Route path="/create-research2/:id">
            <CreateResearch2 />
          </Route>

          <Route path="/profile">
            <Profile />
          </Route>

          <Route path="/orders">
            <Order />
          </Route>

          <Route path="/forgot-password">
            <ForgotPassword />
          </Route>

          <Route path="/reset-password/:id">
            <ResetPassword />
          </Route>

          <Route path="/reset-success">
            <ResetSuccess />
          </Route>
          <Route path="/rbf-ml/:id?">
            <Rbfml />
          </Route>

          <Route path="/blockchain">
            <Blockchain />
          </Route>

            <Route path="/">
              <Home />
            </Route>
            <Redirect to="/" />
          </Switch>
        </Suspense>
      </Router>
    );
  }
}

export default App;
